import React from 'react';

const Maintenance = () => {
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column', textAlign: 'center' }}>
                <img src="img/resources/alt_logo_300.png" alt="TSH Logo" />

                <h1 style={{ textAlign: 'center' }}>Down for Maintenance</h1>
                <p style={{ textAlign: 'center' }}>This page is currently under maintenance. Please check back later.</p>
                <button 
                    onClick={() => window.location.href = '/status'} 
                    className='btn btn-primary'
                    style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px', cursor: 'pointer' }}
                >
                    Check Repair Status
                </button>
            </div>
            <style>
                {`
                        body {
                            background-color: #333;
                            color: white;
                        }
                    `}
            </style>
        </>
    );
};

export default Maintenance;